"use client";

import React, { useEffect, useState } from 'react';
import { useParams } from 'next/navigation';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AsioPrimitivesProvider } from '@rich-products-corp/primitives-richproducts';
import { Toast } from '@rich-products-corp/react-ecomm-ui/dist';
import { ThemeContext } from '@rich-products-corp/react-ecomm-ui/dist/components/contexts/theme';
import { FrontasticProvider, fetchApiHub } from 'frontastic';
import { LoadingProvider } from 'frontastic/provider/loading/LoadingProvider';
import { setCookie } from 'cookies-next';
import { TrackJS } from 'trackjs';
import Toaster from 'components/commercetools-ui/toaster';
import { defaultTheme } from '../../styles/themes/default';
import { sdk } from '@/sdk';

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(() => new QueryClient());
  const params = useParams();
  
  const locale = params?.locale as string;

  if (locale) {
    sdk.defaultConfigure(locale);
  }

  useEffect(() => {
    window.dispatchEvent(new CustomEvent('REACTReady'));
    TrackJS.install({ token: process.env.TRACKJS_TOKEN as any });

    const getTokenDetails = async () => {
      try {
        const res: any = await fetchApiHub('/action/account/getTokenDetails', { method: 'POST' }, {});
        if (res?.token) {
          setCookie('asio_session', JSON.stringify(res));
        }
      } catch (err) {
        console.error("Failed to fetch token details", err);
      }
    };

    getTokenDetails();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <AsioPrimitivesProvider>
        <LoadingProvider>
          <FrontasticProvider>
            <ThemeContext.Provider value={{ theme: defaultTheme }}>
              {children}
            </ThemeContext.Provider>
            <Toaster />
            <Toast.Toaster />
          </FrontasticProvider>
        </LoadingProvider>
      </AsioPrimitivesProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
